import { Injectable } from '@angular/core';

// Services
import { RouteParam, ServiceBase } from '../service-base';

const CLASS_NAME = 'PaymentProvider';
const ENDPOINT = `/payment-providers/`;

const ROUTES: RouteParam[] = [
    { key: 'massDelete', path: 'mass-delete/' },
]

@Injectable({
    providedIn: 'root'
})
export class PaymentProviderService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
        this.addRoutes(ROUTES);
    }
}
